var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspireCreativeThinkingandProblemSolving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 45H0C0 39.9282 4.23599 35.8163 9.46236 35.8163H35.5383C40.764 35.8163 45 39.9282 45 45Z",
    fill: "#256BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8335 32C28.2452 29.8247 26.4233 27.9759 24.8397 26.3688C22.648 24.1447 20.9126 22.3837 20.8841 20.8609C20.9686 17.6163 25.5944 17.2134 28.9704 22.2015C30.2234 23.9404 31.6508 22.7838 33.1121 21.0542C35.0206 21.3545 35.6067 20.9779 36.3611 20.2235C37.7854 18.2543 36.6269 17.1528 35.6761 16.511C32.7468 14.4656 31.0326 12.1823 29.5659 10.2287L29.5659 10.2287C27.2858 7.1917 25.6039 4.95143 20.8848 5.64044V0C17.9742 0.830709 16.324 3.34098 15.1649 6.50493C5.55819 13.3122 5.75972 22.2625 9.56198 32H29.8335Z",
    fill: "#171C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspireCreativeThinkingandProblemSolving);
export default __webpack_public_path__ + "static/media/InspireCreativeThinkingandProblem-Solving.310b08339e3b1b664d76157d0f8ad2d5.svg";
export { ForwardRef as ReactComponent };